import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import { useAuth } from '@/context/AuthContext';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const SiparisDetay = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const { canEdit, user } = useAuth();
  const [activeTab, setActiveTab] = useState('genel');
  const [loading, setLoading] = useState(true);
  const [musteriler, setMusteriler] = useState([]);
  const [vincler, setVincler] = useState([]);
  const [showVincModal, setShowVincModal] = useState(false);
  const [formData, setFormData] = useState({
    musteri_id: '',
    siparis_no: '',
    tutar: 0,
    para_birimi: 'TL',
    durum: 'Beklemede',
    siparis_tarihi: '',
    sozlesme_tarihi: '',
    termin_tarihi: '',
    uretim_tarihi: '',
    sevkiyat_tarihi: '',
    teslim_tarihi: '',
    notlar: '',
    dosyalar: [],
    sohbet: []
  });
  const [newVinc, setNewVinc] = useState({ seri_no: '', vinc_tipi: 'Köprü', kapasite: '', yukseklik: '', aciklik: '' });
  const [newMessage, setNewMessage] = useState('');
  const [newFile, setNewFile] = useState({ dosya_adi: '', dosya_yolu: '', aciklama: '' });
  const [selectedFile, setSelectedFile] = useState(null);
  const [uploading, setUploading] = useState(false);

  useEffect(() => {
    fetchData();
  }, [id]);

  const fetchData = async () => {
    try {
      const [siparisRes, musterilerRes, vinclerRes] = await Promise.all([
        axios.get(`${API}/siparisler/${id}`),
        axios.get(`${API}/musteriler`),
        axios.get(`${API}/vincler/by-siparis/${id}`)
      ]);
      const data = siparisRes.data;
      // Tarihleri input formatına çevir
      ['siparis_tarihi', 'sozlesme_tarihi', 'termin_tarihi', 'uretim_tarihi', 'sevkiyat_tarihi', 'teslim_tarihi'].forEach(field => {
        if (data[field]) {
          data[field] = new Date(data[field]).toISOString().split('T')[0];
        }
      });
      setFormData(data);
      setMusteriler(musterilerRes.data);
      setVincler(vinclerRes.data);
    } catch (error) {
      console.error('Veri yüklenirken hata:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleSave = async () => {
    try {
      const submitData = { ...formData };
      // Tarihleri ISO formatına çevir
      ['siparis_tarihi', 'sozlesme_tarihi', 'termin_tarihi', 'uretim_tarihi', 'sevkiyat_tarihi', 'teslim_tarihi'].forEach(field => {
        if (submitData[field]) {
          submitData[field] = submitData[field] + 'T12:00:00.000Z';
        } else {
          submitData[field] = null;
        }
      });
      await axios.put(`${API}/siparisler/${id}`, submitData);
      alert('Sipariş kaydedildi!');
    } catch (error) {
      alert('Sipariş kaydedilemedi');
    }
  };

  const handleAddVinc = async () => {
    try {
      await axios.post(`${API}/siparisler/${id}/vinc`, newVinc);
      setShowVincModal(false);
      setNewVinc({ seri_no: '', vinc_tipi: 'Köprü', kapasite: '', yukseklik: '', aciklik: '' });
      fetchData();
      alert('Vinç eklendi!');
    } catch (error) {
      alert('Vinç eklenemedi');
    }
  };

  const handleAddMessage = async () => {
    if (!newMessage.trim()) return;
    try {
      await axios.post(`${API}/siparisler/${id}/mesaj`, { mesaj: newMessage });
      setNewMessage('');
      fetchData();
    } catch (error) {
      console.error('Mesaj eklenirken hata:', error);
    }
  };

  const handleFileSelect = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    
    setSelectedFile(file);
    setNewFile({ ...newFile, dosya_adi: file.name });
  };

  const handleAddFile = async () => {
    if (!selectedFile) {
      alert('Lütfen bir dosya seçin');
      return;
    }
    
    setUploading(true);
    
    try {
      // Upload file first
      const formData = new FormData();
      formData.append('file', selectedFile);
      
      const uploadRes = await axios.post(`${API}/upload`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });
      
      // Add file record to order
      await axios.post(`${API}/siparisler/${id}/dosya`, {
        dosya_adi: newFile.dosya_adi || selectedFile.name,
        dosya_yolu: uploadRes.data.url,
        aciklama: newFile.aciklama
      });
      
      setNewFile({ dosya_adi: '', dosya_yolu: '', aciklama: '' });
      setSelectedFile(null);
      fetchData();
      alert('Dosya başarıyla yüklendi!');
    } catch (error) {
      console.error('Dosya yüklenirken hata:', error);
      alert('Dosya yüklenemedi: ' + (error.response?.data?.detail || error.message));
    } finally {
      setUploading(false);
    }
  };

  const handleDeleteFile = async (fileIndex) => {
    if (!window.confirm('Bu dosyayı silmek istediğinize emin misiniz?')) return;
    
    try {
      await axios.delete(`${API}/siparisler/${id}/dosya/${fileIndex}`);
      fetchData();
      alert('Dosya silindi!');
    } catch (error) {
      console.error('Dosya silinirken hata:', error);
      alert('Dosya silinemedi');
    }
  };

  const formatTarih = (tarih) => {
    if (!tarih) return '-';
    return new Date(tarih).toLocaleDateString('tr-TR');
  };

  if (loading) return <div className="loading">Yükleniyor...</div>;

  const getMusteriAdi = () => {
    const musteri = musteriler.find(m => m.id === formData.musteri_id);
    return musteri ? musteri.ad : '';
  };

  return (
    <div>
      <div className="page-header">
        <h1 className="page-title">Sipariş Detay: {formData.siparis_no}</h1>
        <p className="page-subtitle">{getMusteriAdi()}</p>
      </div>

      <div style={{ display: 'flex', gap: '8px', marginBottom: '24px', borderBottom: '2px solid #e2e8f0' }}>
        {['genel', 'vincler', 'mesajlar', 'dosyalar'].map(tab => (
          <button
            key={tab}
            onClick={() => setActiveTab(tab)}
            style={{
              padding: '12px 24px',
              background: activeTab === tab ? '#3b82f6' : 'transparent',
              color: activeTab === tab ? 'white' : '#64748b',
              border: 'none',
              borderRadius: '8px 8px 0 0',
              fontSize: '14px',
              fontWeight: 600,
              cursor: 'pointer'
            }}
            data-testid={`tab-${tab}`}
          >
            {tab === 'genel' ? 'Genel' : tab === 'vincler' ? 'Vinçler' : tab === 'mesajlar' ? 'Sipariş Mesajları' : 'Sipariş Dosyaları'}
          </button>
        ))}
      </div>

      {activeTab === 'genel' && (
        <div>
          {/* Sipariş Bilgileri */}
          <div className="card">
            <h3>Sipariş Bilgileri</h3>
            <div className="form-grid">
              <div className="form-group">
                <label className="form-label">Müşteri</label>
                <select 
                  className="form-select" 
                  value={formData.musteri_id} 
                  onChange={(e) => setFormData({...formData, musteri_id: e.target.value})} 
                  disabled={!canEdit()}
                >
                  <option value="">Müşteri seçiniz</option>
                  {musteriler.map(m => (
                    <option key={m.id} value={m.id}>{m.ad}</option>
                  ))}
                </select>
                {canEdit() && <small style={{color: '#666', fontSize: '12px', marginTop: '4px', display: 'block'}}>💡 Müşteri değiştirilebilir</small>}
              </div>
              <div className="form-group">
                <label className="form-label">Sipariş No</label>
                <input type="text" className="form-input" value={formData.siparis_no} onChange={(e) => setFormData({...formData, siparis_no: e.target.value})} disabled={!canEdit()} />
              </div>
            </div>
            <div className="form-grid">
              <div className="form-group">
                <label className="form-label">Tutar</label>
                <input type="number" className="form-input" value={formData.tutar} onChange={(e) => setFormData({...formData, tutar: parseFloat(e.target.value)})} disabled={!canEdit()} />
              </div>
              <div className="form-group">
                <label className="form-label">Para Birimi</label>
                <select className="form-select" value={formData.para_birimi} onChange={(e) => setFormData({...formData, para_birimi: e.target.value})} disabled={!canEdit()}>
                  <option value="TL">TL</option>
                  <option value="USD">USD</option>
                  <option value="EUR">EUR</option>
                </select>
              </div>
            </div>
            <div className="form-group">
              <label className="form-label">Durum</label>
              <select className="form-select" value={formData.durum} onChange={(e) => setFormData({...formData, durum: e.target.value})} disabled={!canEdit()}>
                <option value="Beklemede">Beklemede</option>
                <option value="Üretimde">Üretimde</option>
                <option value="Boyamada">Boyamada</option>
                <option value="Montajda">Montajda</option>
                <option value="Teslim Edildi">Teslim Edildi</option>
              </select>
            </div>
          </div>

          {/* Tarihler */}
          <div className="card" style={{marginTop: '24px'}}>
            <h3>Tarihler</h3>
            <div className="form-grid">
              <div className="form-group">
                <label className="form-label">Sipariş Tarihi</label>
                <input 
                  type="date" 
                  className="form-input" 
                  value={formData.siparis_tarihi || ''} 
                  onChange={(e) => setFormData({...formData, siparis_tarihi: e.target.value})} 
                  disabled={!canEdit()} 
                />
              </div>
              <div className="form-group">
                <label className="form-label">Sözleşme Tarihi</label>
                <input 
                  type="date" 
                  className="form-input" 
                  value={formData.sozlesme_tarihi || ''} 
                  onChange={(e) => setFormData({...formData, sozlesme_tarihi: e.target.value})} 
                  disabled={!canEdit()} 
                />
              </div>
            </div>
            <div className="form-grid">
              <div className="form-group">
                <label className="form-label">Termin Tarihi</label>
                <input 
                  type="date" 
                  className="form-input" 
                  value={formData.termin_tarihi || ''} 
                  onChange={(e) => setFormData({...formData, termin_tarihi: e.target.value})} 
                  disabled={!canEdit()} 
                />
              </div>
              <div className="form-group">
                <label className="form-label">Üretim Tarihi</label>
                <input 
                  type="date" 
                  className="form-input" 
                  value={formData.uretim_tarihi || ''} 
                  onChange={(e) => setFormData({...formData, uretim_tarihi: e.target.value})} 
                  disabled={!canEdit()} 
                />
              </div>
            </div>
            <div className="form-grid">
              <div className="form-group">
                <label className="form-label">Sevkiyat Tarihi</label>
                <input 
                  type="date" 
                  className="form-input" 
                  value={formData.sevkiyat_tarihi || ''} 
                  onChange={(e) => setFormData({...formData, sevkiyat_tarihi: e.target.value})} 
                  disabled={!canEdit()} 
                />
              </div>
              <div className="form-group">
                <label className="form-label">Teslim Tarihi</label>
                <input 
                  type="date" 
                  className="form-input" 
                  value={formData.teslim_tarihi || ''} 
                  onChange={(e) => setFormData({...formData, teslim_tarihi: e.target.value})} 
                  disabled={!canEdit()} 
                />
              </div>
            </div>
          </div>

          {/* Notlar */}
          <div className="card" style={{marginTop: '24px'}}>
            <h3>Notlar</h3>
            <div className="form-group">
              <textarea
                className="form-textarea"
                value={formData.notlar || ''}
                onChange={(e) => setFormData({...formData, notlar: e.target.value})}
                rows={5}
                placeholder="Sipariş notları..."
                disabled={!canEdit()}
              />
            </div>
          </div>

          {/* Kaydet Butonu */}
          {canEdit() && (
            <div style={{marginTop: '24px'}}>
              <button className="btn btn-primary" onClick={handleSave}>Kaydet</button>
            </div>
          )}

          {/* Vinçler Tablosu */}
          <div className="card" style={{marginTop: '24px'}}>
            <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px'}}>
              <h3 style={{margin: 0}}>Vinçler</h3>
              {canEdit() && <button className="btn btn-primary" onClick={() => setShowVincModal(true)} data-testid="add-vinc-btn">+ Vinç Ekle</button>}
            </div>
            {vincler.length === 0 ? (
              <p style={{color: '#64748b', textAlign: 'center', padding: '20px'}}>Henüz vinç eklenmemiş</p>
            ) : (
              <table className="table">
                <thead>
                  <tr>
                    <th>Seri No</th>
                    <th>Tip</th>
                    <th>Kapasite</th>
                    <th>Yükseklik</th>
                    <th>Açıklık</th>
                    <th>İşlemler</th>
                  </tr>
                </thead>
                <tbody>
                  {vincler.map(vinc => (
                    <tr key={vinc.id}>
                      <td style={{fontWeight: 600}}>{vinc.seri_no}</td>
                      <td>{vinc.vinc_tipi}</td>
                      <td>{vinc.kapasite}</td>
                      <td>{vinc.yukseklik}</td>
                      <td>{vinc.aciklik}</td>
                      <td>
                        <button className="btn btn-secondary" style={{padding: '6px 12px', fontSize: '12px'}} onClick={() => setActiveTab('vincler')}>Detay</button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>
        </div>
      )}

      {activeTab === 'vincler' && (
        <div className="card">
          <h3>Vinç Detayları</h3>
          {vincler.length === 0 ? (
            <p style={{color: '#64748b', textAlign: 'center', padding: '40px'}}>Henüz vinç eklenmemiş</p>
          ) : (
            vincler.map(vinc => (
              <div key={vinc.id} style={{ padding: '20px', background: '#f8fafc', borderRadius: '8px', marginBottom: '16px' }}>
                <div style={{display: 'flex', justifyContent: 'space-between', marginBottom: '16px'}}>
                  <h4 style={{margin: 0}}>{vinc.seri_no} - {vinc.vinc_tipi}</h4>
                  {canEdit() && <button className="btn btn-primary" onClick={() => navigate(`/vincler/${vinc.id}`)}>Detaylı Düzenle</button>}
                </div>
                <div style={{display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '12px', fontSize: '14px'}}>
                  <div><strong>Kapasite:</strong> {vinc.kapasite}</div>
                  <div><strong>Açıklık:</strong> {vinc.aciklik}</div>
                  <div><strong>Yükseklik:</strong> {vinc.yukseklik}</div>
                </div>
              </div>
            ))
          )}
        </div>
      )}

      {activeTab === 'mesajlar' && (
        <div className="card">
          <h3>Sipariş Mesajları / Chat</h3>
          <div style={{maxHeight: '400px', overflowY: 'auto', marginBottom: '20px'}}>
            {formData.sohbet && formData.sohbet.length > 0 ? (
              formData.sohbet.map((msg, idx) => (
                <div key={idx} style={{ padding: '12px', background: '#f8fafc', borderRadius: '8px', marginBottom: '8px', borderLeft: '4px solid #3b82f6' }}>
                  <div style={{display: 'flex', justifyContent: 'space-between', marginBottom: '6px'}}>
                    <strong style={{color: '#1e293b'}}>{msg.kullanici}</strong>
                    <span style={{fontSize: '12px', color: '#64748b'}}>{new Date(msg.tarih).toLocaleString('tr-TR')}</span>
                  </div>
                  <div style={{color: '#475569'}}>{msg.mesaj}</div>
                </div>
              ))
            ) : (
              <p style={{color: '#64748b', textAlign: 'center', padding: '20px'}}>Henüz mesaj yok</p>
            )}
          </div>
          <div style={{display: 'flex', gap: '12px'}}>
            <textarea className="form-textarea" placeholder="Mesajınızı yazın..." value={newMessage} onChange={(e) => setNewMessage(e.target.value)} rows={3} style={{flex: 1}} />
            <button className="btn btn-primary" onClick={handleAddMessage} style={{alignSelf: 'flex-end'}}>Gönder</button>
          </div>
        </div>
      )}

      {activeTab === 'dosyalar' && (
        <div className="card">
          <h3>Sipariş Dosyaları</h3>
          {formData.dosyalar && formData.dosyalar.length > 0 ? (
            <table className="table" style={{marginBottom: '20px'}}>
              <thead>
                <tr>
                  <th>Dosya Adı</th>
                  <th>Açıklama</th>
                  <th>Yükleme Tarihi</th>
                  <th>İşlemler</th>
                </tr>
              </thead>
              <tbody>
                {formData.dosyalar.map((file, idx) => (
                  <tr key={idx}>
                    <td style={{fontWeight: 600}}>{file.dosya_adi}</td>
                    <td>{file.aciklama}</td>
                    <td>{new Date(file.yukleme_tarihi).toLocaleDateString('tr-TR')}</td>
                    <td>
                      <div style={{display: 'flex', gap: '8px'}}>
                        <a 
                          href={encodeURI(file.dosya_yolu)} 
                          target="_blank" 
                          rel="noopener noreferrer" 
                          className="btn btn-primary"
                          style={{padding: '6px 12px', fontSize: '12px', textDecoration: 'none'}}
                        >
                          İndir
                        </a>
                        {canEdit() && (
                          <button 
                            className="btn btn-danger"
                            style={{padding: '6px 12px', fontSize: '12px'}}
                            onClick={() => handleDeleteFile(idx)}
                          >
                            Sil
                          </button>
                        )}
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          ) : (
            <p style={{color: '#64748b', textAlign: 'center', padding: '20px', marginBottom: '20px'}}>Henüz dosya eklenmemiş</p>
          )}
          {canEdit() && (
            <div style={{background: '#f8fafc', padding: '20px', borderRadius: '8px'}}>
              <h4>Yeni Dosya Ekle</h4>
              
              <div className="form-group">
                <label className="form-label">Dosya Seç *</label>
                <input 
                  type="file" 
                  className="form-input" 
                  onChange={handleFileSelect}
                  accept=".pdf,.docx,.xlsx,.xls,.png,.jpg,.jpeg"
                  style={{padding: '8px'}}
                />
                {selectedFile && (
                  <p style={{fontSize: '12px', color: '#64748b', marginTop: '4px'}}>
                    Seçilen: {selectedFile.name} ({(selectedFile.size / 1024).toFixed(2)} KB)
                  </p>
                )}
              </div>
              
              <div className="form-group">
                <label className="form-label">Dosya Adı</label>
                <input 
                  type="text" 
                  className="form-input" 
                  placeholder="Opsiyonel - Boş bırakılırsa dosya adı kullanılır"
                  value={newFile.dosya_adi} 
                  onChange={(e) => setNewFile({...newFile, dosya_adi: e.target.value})} 
                />
              </div>
              
              <div className="form-group">
                <label className="form-label">Açıklama</label>
                <input 
                  type="text" 
                  className="form-input" 
                  placeholder="Dosya açıklaması (örn: Sözleşme kopyası)"
                  value={newFile.aciklama} 
                  onChange={(e) => setNewFile({...newFile, aciklama: e.target.value})} 
                />
              </div>
              
              <button 
                className="btn btn-primary" 
                onClick={handleAddFile}
                disabled={uploading || !selectedFile}
                style={{opacity: (uploading || !selectedFile) ? 0.5 : 1}}
              >
                {uploading ? 'Yükleniyor...' : 'Dosya Yükle'}
              </button>
            </div>
          )}
        </div>
      )}

      {showVincModal && (
        <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }} onClick={() => setShowVincModal(false)}>
          <div style={{ background: 'white', borderRadius: '12px', padding: '24px', width: '500px', maxWidth: '90%' }} onClick={(e) => e.stopPropagation()}>
            <h3>Hızlı Vinç Ekle</h3>
            <div className="form-group">
              <label className="form-label">Vinç Seri No *</label>
              <input type="text" className="form-input" value={newVinc.seri_no} onChange={(e) => setNewVinc({...newVinc, seri_no: e.target.value})} />
            </div>
            <div className="form-group">
              <label className="form-label">Vinç Tipi</label>
              <select className="form-select" value={newVinc.vinc_tipi} onChange={(e) => setNewVinc({...newVinc, vinc_tipi: e.target.value})}>
                <option value="Köprü">Köprü</option>
                <option value="Portal">Portal</option>
                <option value="Monoraylı">Monoraylı</option>
              </select>
            </div>
            <div className="form-grid">
              <div className="form-group">
                <label className="form-label">Kapasite</label>
                <input type="text" className="form-input" value={newVinc.kapasite} onChange={(e) => setNewVinc({...newVinc, kapasite: e.target.value})} />
              </div>
              <div className="form-group">
                <label className="form-label">Yükseklik</label>
                <input type="text" className="form-input" value={newVinc.yukseklik} onChange={(e) => setNewVinc({...newVinc, yukseklik: e.target.value})} />
              </div>
            </div>
            <div className="form-group">
              <label className="form-label">Açıklık</label>
              <input type="text" className="form-input" value={newVinc.aciklik} onChange={(e) => setNewVinc({...newVinc, aciklik: e.target.value})} />
            </div>
            <div style={{display: 'flex', gap: '12px', marginTop: '20px'}}>
              <button className="btn btn-primary" onClick={handleAddVinc}>Kaydet</button>
              <button className="btn btn-secondary" onClick={() => setShowVincModal(false)}>İptal</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default SiparisDetay;
